
<div class="container-fluid pad0" *ngIf="isFromCostTypeList">
    <!-- CostType Show webView -->
    <div class="container-fluid webView" style="padding: 5px;">
        <div class="modal-header" style="border-bottom: none;padding-top: 10px;">
            <div class="col-md-12 col-12 col-xs-12">
                <div class="row">
                    <div class="col-md-9 col-10 col-xs-10" style="padding-left: 0px;">
                        <h4 class="modal-title"><span id="ApntmntHdr">Project Expenses</span></h4>
                    </div>
                    <div class="col-md-3 col-2 col-xs-2" style="display: flex; padding: 0px; justify-content: flex-end; align-items: center;">
                        <div class="btn-darkBlue brdrRadius3" 
                        title="Enter Expense" (click)="openExpenseEntry()" style="cursor:pointer; padding: 4px 10px; margin-right: 10px; font-size: 12px; height: 30px; float: right; line-height: 20px;">
                        <i class="zmdi zmdi-plus" style="margin-right:5px"></i>Enter Expense
                        </div>
                        <div style="padding: 0px;">
                            <i class="closeMdl zmdi zmdi-close" style="float: right; padding: 7px 10px !important; position: relative; top: -2px !important;" 
                            (click)="closeCostTypeMdl()" data-dismiss="modal"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--Body-->
        <div class="modal-body" style="padding: 0px;">
            <div class="row">
                <!-- <div *ngIf="costTypeList.length > 0" class="col-md-12 col-sm-12 col-xs-12" style="padding: 0px 15px;overflow-y: auto; max-height: 60vh;"> -->
                <div class="col-md-12 col-sm-12 col-xs-12" style="padding: 0px 15px;">
                    <div class="col-md-12 col-sm-12 col-xs-12" style="margin-bottom: 15px;">
                        <span class="whiteBtn brdrRadius3" style="cursor:pointer; padding: 6px 6px; margin-right: 10px; font-size: 12px; display: inline-block; height: 30px; line-height: 16px;" >
                            Total Expenses <span style="margin-right:5px; font-weight: 600;">₹ {{costSum  | lacFormat : 1}}</span>
                        </span>
                    </div>
                    
                   <div class="col-md-12 col-sm-12 col-xs-12" style="overflow-y: auto; max-height: 60vh;">
                    <table class="table table-bordered" style="font-size: 12px; background-color: white;" *ngIf="allcostTypesList.length > 0">
                        <thead>
                            <tr>
                                <th style="width: 9%;">Date</th>
                                <th style="width: 15%;">Expense Type</th>
                                <th style="width: 21%;">Description</th>	
                                <th style="width: 8%;text-align: right;">Amount (₹)</th>
                                <th style="width: 12%;">By</th>
                                <th style="width: 1%;"></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let c of allcostTypesList;">
                                <td>{{c.DT | date:'dd-MMM-yy'}}</td>
                                <td>{{c.CNm}}</td>
                                <td>{{c.D ? c.D : '-'}}</td>
                                <td style="text-align: right;">{{c.Amt | lacFormat : 1}}</td>
                                <td>{{c.userName ? c.userName : '-'}}</td>
                                <td style="text-align: center;">
                                    <span  class="lableBtnGray" (click)="fn_deleteExpenseType(c)"  title="Delete" style="border-radius: 10px; vertical-align: middle; cursor: pointer;">
                                        <i class="fa fa-trash"></i></span>
                                </td>                           
                        </tbody>
                    </table>
                   </div>
                  
                </div>
             
                <!-- (click)="openCostTypeMdl(costType,0)"  -->
                <div *ngIf="allcostTypesList.length == 0"  class="col-md-12 col-12 col-sm-12 pad0" style="padding: 5px 0px 15px 25px;">
                    <div class="nrf" style="cursor: pointer; padding: 7px 12px;">No record found.</div>
                </div>
            </div>
        </div>
    </div>

     <!-- CostType Show mobView -->
     <!-- Mobile View -->
    <div class="container mobView" style="background-color: #f8f8f8;width: 100%;">
        <div class="modal-header" style="border-bottom: none;padding: 8px;">
            <div class="col-md-12 col-12 col-xs-12 pad0">
                <div class="row">
                    <div class="col-md-9 col-10 col-xs-10 pad0">
                        <h4 class="modal-title">Total Expenses</h4>
                    </div>
                    <div class="col-md-3 col-2 col-xs-2" style="padding: 0px;">
                        <i class="closeMdl zmdi zmdi-close" style="float: right; padding: 7px 10px !important;position: relative;top: -4px !important;" 
                        (click)="closeCostTypeMdl()" data-dismiss="modal"></i>
                    </div>
                </div>
            </div>
        </div>
        <!--Body-->
        <div class="modal-body pad0">
            <div class="row">
                <!-- <div *ngIf="costTypeList.length > 0" class="col-md-12 col-sm-12 col-xs-12" style="padding: 0px 15px;overflow-y: auto; max-height: 60vh;"> -->     
                 
                    <!-- List -->
                
                        <div class="col-md-12 col-sm-12 col-12 bgWhite marginTp font13"
                            *ngFor="let c of allcostTypesList" style="padding:12px;">
                            <div class="col-md-12 col-12 col-sm-12 pad0">
                                <div class="col-md-8 col-8 col-sm-8 pad0 inLneBlk" style="width:80%;">
                                    <span style="font-weight: bold;">{{c.CNm}}</span>
                                </div>
                                <div  class="col-md-2 col-xs-2 col-sm-2 pad0 inLneBlk txtRight"style="width:20%;    float: right;">
                                    <span  style="margin-left: 5px;padding: 3px 6px; border-radius: 50%;"
                                    (click)="fn_deleteExpenseType(c)">
                                        <i class="fa fa-times" style="color: #777;"></i>
                                    </span>
                                </div>
                               
                            </div>
                            <div class="col-md-12 col-12 col-sm-12 pad0 inLneBlk">
                                <div class="col-md-8 col-8 col-sm-8 inLneBlk pad0 font12" style="width:60%">
                                    <span style="position: relative; margin-right: 5px;"> <i class="fa fa-user"
                                            style="color: #1f628e;"></i>
                                    </span> 
                                    <span style="color: #777;">{{c.userName ? c.userName : '-'}}</span>
                                </div> 
                                <div  class="col-md-4 col-xs-4 col-sm-4 pad0 inLneBlk txtRight"style="color: #4caf50; width: 40%;">
                                    ₹ {{c.Amt | lacFormat : 1 }}
                                    <!-- <span style="color: #4caf50;">₹ {{c.Amt | lacFormat : 1 }}</span> -->
                                </div>
                            </div>
                            <div class="col-md-12 col-12 col-sm-12 pad0" style="display: inline-block;">
                                <div class="col-md-8 col-8 col-sm-8 pad0 font12" style="display: inline-flex;">
                                    <span class="inLneBlk"><i style="margin-right: 5px; color: #e88421;" class="zmdi zmdi-view-dashboard"></i></span>
                                    <span class="twoLineElips inLneBlk" style="color: #777;">{{c.D ? c.D : '-'}}</span>
                                </div>
                                <div class="col-md-4 col-4 col-sm-4 inLneBlk pad0 txtRight font12" style="color: #777;">
                                    {{c.DT| date:'dd-MMM-yy'}}
                                    <!-- <span style="color: #777;">{{c.DT| date:'dd-MMM-yy'}}</span> -->
                                </div>
                            </div>
                        </div>
              
             
                <div class="col-md-12 col-12 col-sm-12 pad0" style="padding: 15px; margin-top: 0px;" *ngIf="allcostTypesList.length == 0">
                    <div class="nrf">No record found.</div>
                </div>
                    <!-- List end -->                
                </div>                        
            </div>
    </div>
        
</div>




<div class="container-fluid" *ngIf="isFromCostTypeEntry">
    <div class="modal-header" style="border-bottom: none; padding: 0px;">
        <div class="col-md-12 col-12 col-xs-12" style="padding:8px 0px 10px 0px">
            <div class="col-md-9 col-9 col-xs-9" style="padding: 0px; display: inline-block;">
                <h4 class="modal-title"><span id="ApntmntHdr">Enter Expense</span></h4>
            </div>
            <div class="col-md-3 col-3 col-xs-3" style="padding: 0px; display: inline-block;">
                <i class="closeMdl zmdi zmdi-close" style="float: right; padding: 6px 10px !important;position: relative;top: 5px !important;" 
                (click)="closeCostTypeMdl()" data-dismiss="modal"></i>
            </div>
        </div>
    </div>
    <!--Body-->
    <div class="modal-body" style="padding: 8px 2px;">	
        <div class="row" style="padding: 0px">	
            <div class="col-md-12 col-sm-12 col-12 pdng" style="text-align: left;">
                <div class="label-new" style="color: #333;">Select Expense Type</div>
                <!-- <span class="example-full-width font13" style="width: 100%;" appearance="outline"> -->
                    <!-- <select ng-disabled="costTypeList.length == 0" class="form-control bzInput crntColor" 
                    style="padding: 0; background-color: white !important; {{costTypeList.length > 0 ? 'cursor: pointer' : 'cursor: auto'}}" [(ngModel)]="costType.name" tabindex="1">
                        <option value="">Select Expense Type</option>
                        <ng-container *ngFor="let c of costTypeList">
                            <option value="{{c.CNm}}">{{c.CNm}}</option>
                        </ng-container>
                    </select>	 -->
                    <mat-select [disabled]="costTypeList.length === 0" 
                            class="form-control fn13 formCtlFltr crntColor" 
                            [(ngModel)]="costType.name" 
                            placeholder="Select Expense Type"
                            tabindex="1">
                        <mat-option *ngFor="let c of costTypeList" [value]="c.CNm">
                            {{c.CNm}}
                        </mat-option>
                    </mat-select>
                    <!-- <input class="form-control bzInput" autofocus="false"	
                        [(ngModel)]="costType.name" [matAutocomplete]="auto">	
                    <mat-autocomplete #auto="matAutocomplete">	
                        <mat-option *ngFor="let i of costTypeList" [value]="i.CNm">	
                            <span>{{i.CNm}} </span>	
                        </mat-option>	
                    </mat-autocomplete>	 -->
                <!-- </span> -->
            </div>
            
            <div class="col-md-12 col-sm-12 col-12 pdng mrgnTp10">
                <div class="label-new">Amount</div>
                <div class="inrAlignMob">
                    <span class="inLneBlk">
                        <!-- <i class="zmdi zmdi-widgets" style="color: #2b7fb3;"></i> -->
                        <span class="iconBox inrIconMob" style="top: 21px !important; line-height: 21px !important; left: 18px !important; font-size: 13px;">
                            {{'₹'}}
                        </span>
                    </span>
                    <span class="inLneBlk fieldPad floatLeftMob">
                        <span class="example-full-width wdh50" style="text-align: right; height: 30px;" appearance="outline">
                            <!-- <mat-label>Std Cost</mat-label> -->
                            <input class="iconField form-control bzInput crntColor" style="text-align: right; font-size: 13px;" tabindex="2" [(ngModel)]="costType.amount"
                                captalize-first maxlength="10" 
                                (keypress)="CmnService.numberOnly($event)" (keyup)="enterExpenseAmount();" numbers_only>
                        </span>
                    </span>
                </div>
            </div>

            <!-- Description -->
            <div class="col-md-12 col-sm-12 col-12 inLneBlk pdng mrgnTp10" style="text-align: left;">
                <div class="label-new" style="color: #333;">Description</div>
                <textarea rows="4" maxlength="500"  class="txtArea fn13 brdrRadius3 crntColor" style="resize: none; width: 100%; outline: none; padding: 4px;" [(ngModel)]="costType.description" tabindex="3"></textarea>
            </div>	

            <!-- save -->
            <div class="col-md-12 col-xs-12 col-12" style="display: inline-block;padding: 5px 0px 10px 15px;">	
                <span class="btn btn-darkGreen brdrRadius3 " style="padding:  2px 8px;line-height: 23px;font-size: 13px;"	
                    (click)="fn_addCostType()">	
                    <i class="fa fa-check" style="margin-right: 5px;"></i>	
                    <span>Save</span>	
                </span>	
            </div>	
        </div>	
    </div>	
</div>


